"use client";
/* storefront error boundary: on-brand copy in the 404's shape, never the
   raw error text (Server Component errors arrive as a digest only). */
import Link from "next/link";
import { useEffect } from "react";
import "../not-found.css";

export default function SiteError({ error, retry }: { error: Error & { digest?: string }; retry: () => void }) {
  useEffect(() => { console.error(error); }, [error]);
  return (
    <main>
      <section className="shell lost">
        <div className="lost-box">🎀</div>
        <span className="eyebrow" style={{ marginTop: 16 }}>Hmm · the ribbon got tangled</span>
        <h1 className="display" style={{ marginTop: 8 }}>Something slipped, love.</h1>
        <p className="lede" style={{ margin: "14px auto 0", maxWidth: "46ch" }}>This page didn&apos;t load the way it should. Your balance, shelf, and entries are safe exactly where you left them.</p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap", marginTop: 30 }}>
          <button className="btn btn-gold" onClick={() => retry()}>Try again</button>
          <Link className="btn btn-ghost" href="/">Take me home</Link>
        </div>
        {error.digest && <p className="micro" style={{ marginTop: 18 }}>Ref {error.digest} · live support can look it up.</p>}
      </section>
    </main>
  );
}
